import { TextField, TextFieldProps } from '@mui/material'
import get from 'lodash/get'
import React from 'react'
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { correctMeasurement } from '../../../utils'

export type MeasurementFieldControllerProps = TextFieldProps & {
  name: string
  rules?: RegisterOptions
}
const MeasurementFieldController: React.FC<MeasurementFieldControllerProps> = ({
  name,
  rules,
  ...props
}) => {
  const { t } = useTranslation()

  const {
    formState: { errors },
    control,
    setValue,
  } = useFormContext()

  return (
    <Controller
      rules={{
        ...rules,
        required: rules?.required && t('messages:warnings.required'),
      }}
      render={({ field }) => (
        <TextField
          {...field}
          onChange={(e) => {
            const corrected = correctMeasurement(e.target.value)
            setValue(name, corrected, {
              shouldValidate: true,
            })
          }}
          error={!!get(errors, name)}
          helperText={get(errors, [...name.split('.'), 'message']) as string}
          fullWidth
          type="number"
          {...props}
        />
      )}
      name={name}
      control={control}
    />
  )
}

export { MeasurementFieldController }
